import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveBusinessUnits(context, data = {}) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const users = await axios.get('/autodesk/bim-360/account-admin/business-units', config);
        return users.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
